export function removePrefixMaybe(str: string, prefix: string) {
  if (str.startsWith(prefix)) {
    return str.slice(prefix.length);
  }
  return str;
}

export function removePrefixForced(str: string, prefix: string,) {
  if (!str.startsWith(prefix)) {
    throw new Error(`String doesn’t start with ${JSON.stringify(prefix)}: ${JSON.stringify(str)}`);
  }
  return str.slice(prefix.length);
}

export function removeSuffixMaybe(str: string, suffix: string) {
  if (!str.endsWith(suffix)) {
    return str;
  }
  return str.slice(0, -suffix.length);
}

export function removeSuffixForced(str: string, suffix: string) {
  if (!str.endsWith(suffix)) {
    throw new Error(`String doesn’t end with ${JSON.stringify(suffix)}: ${JSON.stringify(str)}`);
  }
  return str.slice(0, -suffix.length);
}
